import { render } from "./PasswordForgottenModal.vue?vue&type=template&id=2e6aa0e0&scoped=true"
import script from "./PasswordForgottenModal.vue?vue&type=script&lang=js"
export * from "./PasswordForgottenModal.vue?vue&type=script&lang=js"

import "./PasswordForgottenModal.vue?vue&type=style&index=0&id=2e6aa0e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6aa0e0"]])

export default __exports__